import { FC, SyntheticEvent, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Tab, Tabs } from '@mui/material';

import { TAdminPageTab } from '@interfaces/admin';

import GlobalMessages from './GlobalMessages/GlobalMessages';
import ImportMedications from './ImportMedications/ImportMedications';
import Organizations from './Organizations/Organizations';
import ProgramCodes from './ProgramCodes/ProgramCodes';

import './style.scss';

const AdminPage: FC = () => {
  const { t } = useTranslation();

  const [activeTab, setActiveTab] = useState(TAdminPageTab.ProgramCodes);

  const handleTabChange = useCallback((event: SyntheticEvent, value: TAdminPageTab) => {
    setActiveTab(value);
  }, []);

  return (
    <Container maxWidth="lg" className="page admin-page">
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        aria-label="Tabs"
        className="admin-page__tabs"
      >
        <Tab value={TAdminPageTab.ProgramCodes} label={`${t('admin.programCodes')}`} />
        <Tab value={TAdminPageTab.Organizations} label={`${t('admin.organizations')}`} />
        <Tab value={TAdminPageTab.ImportMedications} label={`${t('admin.importMedications')}`} />
        <Tab value={TAdminPageTab.GlobalMessages} label={`${t('admin.globalMessages')}`} />
      </Tabs>

      {activeTab === TAdminPageTab.ProgramCodes && <ProgramCodes />}
      {activeTab === TAdminPageTab.Organizations && <Organizations />}
      {activeTab === TAdminPageTab.ImportMedications && <ImportMedications />}
      {activeTab === TAdminPageTab.GlobalMessages && <GlobalMessages />}
    </Container>
  );
};

export default AdminPage;
